class BlobDownloadService {
    constructor(_, $http, initConfigProvider) {
        this._ = _;
        this.http = $http;       
        this.adminApiPath = initConfigProvider.apiBaseUrl + initConfigProvider.adminServiceEndPoint;   
        this.disclosuresApiPath = initConfigProvider.apiBaseUrl + initConfigProvider.disclosureServiceEndPoint;
        this.usersApiPath = initConfigProvider.apiBaseUrl + initConfigProvider.userServiceEndPoint;
    }

    downloadBlob(url, httpMethod, data = null) {
        return this.http({ method:httpMethod, url:url, data:data, responseType: 'blob'}).then((response) => {
            if (response.status === 200) {
                return {
                    data: new Blob([response.data], { type: response.headers()['content-type'] }),
                    error: ''
                };
            } else if (response.status === 204) {
                return {
                    data: null,
                    error: ''
                }
            } else {
                if (response.data && response.data.error) {
                    return {
                        data: null,
                        error: response.data.error,
                        isValidFile: false
                    };
                }
            }
            return {
                data: null,
                error: 'Blob download service error'
            };
        }).catch((error) => {
            return {
                data: null,
                error: 'Blob download service error'
            };
        });
    }

    downloadDisclosurePDF(disclosureId, extractedHtml) {
        let url = `${this.disclosuresApiPath}/${disclosureId}/pdf`;
        return this.downloadBlob(url, "POST", { disclosureId: disclosureId, extractedHtml: extractedHtml});   
    }

    downloadDisclosures(filter) {
        let url = `${this.disclosuresApiPath}/?curtinId=${filter.curtinId || ""}&pageSize=${filter.pageSize || 20}&pageIndex=${filter.pageIndex || 1}
            &displayId=${filter.displayId || ""}&keyword=${filter.keyword || ""}&statusList=${filter.statusList || ""}&sortColumn=${filter.sortColumn || ""}
            &sortDirection=${filter.sortDirection || "Descending"}&disclosureType=${filter.disclosureType || ""}
            &faculty=${filter.faculty || ""}&school=${filter.school || ""}&download=true`;

        return this.downloadBlob(url, "GET");
    }   

    downloadTaskDisclosures(filter) {
        let url = `${this.usersApiPath}/${filter.curtinId}/mytasks?pageSize=${filter.pageSize || 20}&pageIndex=${filter.pageIndex || 1}
            &statusList=${filter.statusList || ""}&sortColumn=${filter.sortColumn || ""}&sortDirection=${filter.sortDirection || "Descending"}&download=true`;

        return this.downloadBlob(url, "GET");
    } 

    downloadAllDisclosures(filter) {
        let url = `${this.adminApiPath}/managedisclosures/?pageSize=${filter.pageSize || 50}&pageIndex=${filter.pageIndex || 1}
            &displayId=${filter.displayId || ""}&keyword=${filter.keyword || ""}&statusList=${filter.statusList || ""}&sortColumn=${filter.sortColumn || ""}
            &sortDirection=${filter.sortDirection || "Descending"}&disclosureType=${filter.disclosureType || ""}
            &faculty=${filter.faculty || ""}&school=${filter.school || ""}&download=true`;

        return this.downloadBlob(url, "GET");
    }

}

BlobDownloadService.$inject = ['_', '$http', 'initConfigProvider'];

export default BlobDownloadService;


// WEBPACK FOOTER //
// ./app/services/blob-download.service.js